import React from "react";
import ProjectCards from "../ProjectCards";

function Projects() {
	return <ProjectCards />;
}

export default Projects;
